import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, euro } from "@/lib/api";

export default function ManualOrder() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [f, setF] = useState({
    gamme_key: "", quantity: 1, mode: "livraison",
    name: "", phone: "", email: "", company: "", postal_code: "", address: "", floor: "", note: "",
  });
  useEffect(() => { api.get("/admin/products").then(({ data }) => { setProducts(data); setF((p) => ({ ...p, gamme_key: data[0]?.gamme_key })); }); }, []);
  const upd = (k, v) => setF({ ...f, [k]: v });

  const submit = async () => {
    try {
      const body = {
        gamme_key: f.gamme_key, quantity: parseInt(f.quantity), mode: f.mode,
        customer: { name: f.name, phone: f.phone, email: f.email, company: f.company },
        delivery: f.mode === "livraison" ? { postal_code: f.postal_code, address: f.address, floor: f.floor } : null,
        note: f.note,
      };
      const { data } = await api.post("/admin/orders/manual", body);
      toast.success(`Réservation ${data.ref} créée`);
      navigate(`/admin/commandes/${data.order_id}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const inp = "w-full h-11 rounded-lg border border-brand-green/20 px-3";

  return (
    <div className="max-w-2xl">
      <h1 className="font-serif text-3xl font-bold text-brand-green mb-6">Nouvelle réservation manuelle</h1>
      <div className="bg-white rounded-xl border border-brand-green/10 p-5 space-y-4">
        <div className="grid sm:grid-cols-2 gap-3">
          <div><label className="text-xs text-brand-green/60">Gamme</label>
            <select data-testid="manual-gamme" value={f.gamme_key} onChange={(e) => upd("gamme_key", e.target.value)} className={inp}>
              {products.map((p) => <option key={p.gamme_key} value={p.gamme_key}>{p.name} — {euro(p.price_ttc)}</option>)}
            </select>
          </div>
          <div><label className="text-xs text-brand-green/60">Quantité</label><input type="number" data-testid="manual-qty" value={f.quantity} onChange={(e) => upd("quantity", e.target.value)} className={inp} /></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <input data-testid="manual-name" value={f.name} onChange={(e) => upd("name", e.target.value)} placeholder="Nom *" className={inp} type="text" autoComplete="name" autoCapitalize="words" />
          <input data-testid="manual-phone" value={f.phone} onChange={(e) => upd("phone", e.target.value)} placeholder="Téléphone *" className={inp} type="tel" inputMode="tel" autoComplete="tel" />
          <input data-testid="manual-email" value={f.email} onChange={(e) => upd("email", e.target.value)} placeholder="Email" className={inp} type="email" inputMode="email" autoCapitalize="off" autoCorrect="off" spellCheck={false} />
          <input value={f.company} onChange={(e) => upd("company", e.target.value)} placeholder="Société" className={inp} type="text" autoComplete="organization" />
        </div>
        <div><label className="text-xs text-brand-green/60">Mode</label>
          <select data-testid="manual-mode" value={f.mode} onChange={(e) => upd("mode", e.target.value)} className={inp}><option value="livraison">Livraison</option><option value="retrait">Retrait</option></select>
        </div>
        {f.mode === "livraison" && (
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="manual-postal" value={f.postal_code} onChange={(e) => upd("postal_code", e.target.value.replace(/\D/g, ""))} placeholder="Code postal" className={inp} maxLength={5} type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="postal-code" />
            <input data-testid="manual-address" value={f.address} onChange={(e) => upd("address", e.target.value)} placeholder="Adresse" className={inp} type="text" autoComplete="street-address" />
          </div>
        )}
        <textarea data-testid="manual-note" value={f.note} onChange={(e) => upd("note", e.target.value)} placeholder="Note (préférences, précisions…)" className="w-full rounded-lg border border-brand-green/20 p-3" rows={2} />
        <p className="text-xs text-brand-green/50">Le règlement (espèces ou Revolut) se convient par téléphone. Aucun paiement en ligne.</p>
        <button data-testid="manual-submit" onClick={submit} className="rounded-full bg-brand-gold text-brand-green px-8 py-3 font-bold">Créer la réservation</button>
      </div>
    </div>
  );
}
